import generateTypes from '../utils/generateTypes';

export const GET_LABELS = generateTypes('GET_LABELS');
export const RESET_LABELS = generateTypes('RESET_LABELS');
